export const userNavTypes = {
    USER_NAV_SET: 'USER_NAV_SET',
    USER_NAVS_SET: 'USER_NAVS_SET',
    USER_NAV_DELETE: 'DASHBOARD_DELETE',
}
